import { useTranslation } from "react-i18next";

export default function BackgroundSection() {
  const { t, i18n } = useTranslation();
  const isJa = i18n.language === "ja";

  return (
    <section id="background" className="w-full bg-white py-24 md:py-32">
      <div className="max-w-7xl mx-auto px-6 grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
        {/* Text */}
        <div>
          <p className="text-[#BF9B5E] text-xs font-semibold tracking-[0.3em] uppercase mb-5">
            {t("bg_label")}
          </p>
          <h2
            className={`text-[#1a1a1a] font-bold leading-snug mb-8 ${
              isJa
                ? "text-3xl md:text-4xl max-w-sm"
                : "text-2xl md:text-3xl max-w-md"
            }`}
          >
            {t("bg_title")}
          </h2>
          <p
            className={`text-gray-600 leading-loose mb-5 ${
              isJa ? "text-sm md:text-base max-w-lg" : "text-sm md:text-base max-w-lg"
            }`}
          >
            {t("bg_text1")}
          </p>
          <p
            className={`text-gray-600 leading-loose mb-8 ${
              isJa ? "text-sm md:text-base max-w-lg" : "text-sm md:text-base max-w-lg"
            }`}
          >
            {t("bg_text2")}
          </p>
          <div className="border-l-4 border-[#BF9B5E] pl-6 py-1 max-w-md">
            <p
              className={`text-[#1a1a1a] font-medium italic leading-relaxed ${
                isJa ? "text-base md:text-lg" : "text-sm md:text-base"
              }`}
            >
              &ldquo;{t("bg_question")}&rdquo;
            </p>
          </div>
        </div>

        {/* Image */}
        <div className="relative">
          <div className="w-full h-[420px] overflow-hidden">
            <img
              src="https://public.readdy.ai/ai/img_res/9cbddc70a66c816d5b5e8be88c6457a9.jpg"
              alt="Business professionals in New Jersey"
              className="w-full h-full object-cover object-top"
            />
          </div>
          {/* Decorative accent */}
          <div className="absolute -bottom-4 -left-4 w-24 h-24 border-2 border-[#BF9B5E] -z-10" />
        </div>
      </div>

      {/* Community overview below */}
      <div className="max-w-7xl mx-auto px-6 mt-24 md:mt-32">
        <div className="bg-[#f8f6f2] p-12 md:p-16">
          <p className="text-[#BF9B5E] text-xs font-semibold tracking-[0.3em] uppercase mb-5">
            {t("community_label")}
          </p>
          <h2
            className={`text-[#1a1a1a] font-bold leading-snug mb-6 ${
              isJa
                ? "text-3xl md:text-4xl max-w-md"
                : "text-2xl md:text-3xl max-w-lg"
            }`}
          >
            {t("community_title")}
          </h2>
          <p
            className={`text-gray-600 leading-loose ${
              isJa ? "text-sm md:text-base max-w-3xl" : "text-sm md:text-base max-w-3xl"
            }`}
          >
            {t("community_text")}
          </p>
        </div>
      </div>
    </section>
  );
}
